export default __webpack_public_path__ + "static/media/Background_00148.83976aad.png";